import i18next from "i18next";
import config from "./config.json"
import customConfig from "./customConfig.json"

export const MainConfig = config
export const CustomConfig = customConfig

export const getMarriageDateTime = () => {
    const marriageDate = config.basicInfo.weddingDate;
    const marriageTime = config.basicInfo.weddingTime;
    return new Date(`${marriageDate}T${marriageTime}`);
}

export const getMarriageDateString = () => {
    const dateTime = getMarriageDateTime();
    const language = getLanguage();
    const month = dateTime.toLocaleString(language, { month: 'long' });
    const capitalizedMonth = month.charAt(0).toUpperCase() + month.slice(1);
    return `${dateTime.getDate()} ${capitalizedMonth} ${dateTime.getFullYear()}`
}

export const getMarriageTimeString = () => {
    const dateTime = getMarriageDateTime();
    return dateTime.toLocaleTimeString(getLanguage(), {
        hour: 'numeric',
        minute: '2-digit',
        hour12: getLanguage().startsWith('en') // Automatically sets AM/PM for English
    });
}

const getLanguage = () => {
    return i18next.language
}